var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_vm._v("\n  加入成功！\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }